import { exportType } from '../components/Common/Table/utils';
import React, { useState } from 'react';
import Routes from '../routes';
import toast from 'react-hot-toast';

const postFetch = async (routes, body, props) => await fetch(routes, {
    method: "POST",
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    ...(body && { body: body }),
    ...props
});

const getFetch = async (route) => await fetch(route, {
    method: "GET",
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
});

const getFormattedFile = (file) => {
    return {
        fileName: file.file.name,
        fileBytes: file.data,
        contentType: file.file.type
    };
};

const toastOptions = { duration: 10000 };

const useBulkUpdates = () => {

    const [isLoading, setIsLoading] = useState(false);

    const BatchUpdateExportServiceEvents = async () => {
        const response = await getFetch(Routes.ServiceEvents.GetBatchUpdateExport());
        console.log('BatchUpdateExportServiceEvents', { response })
        const URL = await Promise.resolve(response.json());
        window.open(URL, "_blank").focus();
    };

    const BatchUpdateExportAsset = async () => {
        const response = await getFetch(Routes.Asset.GetBatchUpdateExport());
        console.log('BatchUpdateExportAsset', { response })
        const URL = await Promise.resolve(response.json());
        window.open(URL, "_blank").focus();
    };

    const BatchUpdateExportWorkOrders = async (options) => {
        const { sort, filters } = options;
        const response = await fetch(Routes.WorkOrder.Export(), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sortBy: sort,
                filters: filters,
                exportType: exportType.xlsx,
            }),
            responseType: 'blob'
        });
        if (response.status === 200) {
            const data = await response.blob();
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(data);
            link.setAttribute('download', 'BulkUpdateWorkOrder.xlsx');
            document.body.appendChild(link);
            link.click();
        } else {
            toast.error('Work Orders template download failed', toastOptions);
        }
    };

    const BatchUpdateImportServiceEvents = async (file) => {
        const formattedFile = getFormattedFile(file);

        const response = await postFetch(
            Routes.ServiceEvents.BulkUpdate(),
            JSON.stringify(formattedFile),
            { responseType: 'blob' }
        );

        const data = await response.blob();
        const text = await data.text();

        if (response.status === 200 || response.status === 202 || (response.status === 500 && data && text !== '"INVALID_TEMPLATE"')) {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(data, { type: file.file.type });
            link.setAttribute('download', 'BulkUpdateServiceEvent.xlsx');
            document.body.appendChild(link);
            link.click();
        return handleBatchUpdateStatus(response.status, 'The service events have been successfully updated.');

        }

        return toast.error('Bulk update is not possible. Please use the template and format provided.', toastOptions);
    };

    const BatchUpdateImportAsset = async (file) => {
        const formattedFile = getFormattedFile(file);

        const response = await postFetch(
            Routes.Asset.BulkUpdate(),
            JSON.stringify(formattedFile),
            { responseType: 'blob' }
        );

        const data = await response.blob();

        if (response.status === 200 || (response.status === 500 && data)) {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(data, { type: file.file.type });
            link.setAttribute('download', 'BulkUpdateInventory.xlsx');
            document.body.appendChild(link);
            link.click();

            if (response.status === 200) {
                return toast.success('The inventory has been successfully updated.', toastOptions);
            }

            return toast.error('Update not successful, please review errors.', toastOptions);
        }

        return toast.error('Bulk update is not possible. Please use the template and format provided.', toastOptions);
    };

    const BatchUpdateImportWorkOrders = async (file) => {
        const formattedFile = getFormattedFile(file);
        
            const response = await postFetch(
                Routes.WorkOrder.BulkUpdate(),
                JSON.stringify(formattedFile),
                { responseType: 'blob' }
            );

            const data = await response.blob();
            const text = await data.text();

            if (response.status === 200 || response.status === 202 || (response.status === 500 && data && text !== '"INVALID_TEMPLATE"')) {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(data, { type: file.file.type });
                link.setAttribute('download', 'BulkUpdateWorkOrder.xlsx');
                document.body.appendChild(link);
                link.click();
    
                return handleBatchUpdateStatus(response.status, 'The Workorder has been successfully updated.');
            }


            return toast.error('Bulk update is not possible. Please use the template and format provided.', toastOptions);
    };

    const BatchUpdateExport = async (batchUpdateType, options = {}) => {
        if (!batchUpdateType) return null;

        setIsLoading(true);
        const batchUpdateFunctionTypes = {
            serviceEvents: BatchUpdateExportServiceEvents,
            assets: BatchUpdateExportAsset,
            workOrders: () => BatchUpdateExportWorkOrders(options)
        };

        const exportFunction = batchUpdateFunctionTypes[batchUpdateType];
        await exportFunction();
        setIsLoading(false);
    };

    const BatchUpdateImport = async (batchUpdateType, excelFile) => {
        if (!batchUpdateType) return null;

        setIsLoading(true);
        const batchUpdateImportFunctionTypes = {
            serviceEvents: () => BatchUpdateImportServiceEvents(excelFile),
            assets: () => BatchUpdateImportAsset(excelFile),
            workOrders: () => BatchUpdateImportWorkOrders(excelFile)
        };

        const exportFunction = batchUpdateImportFunctionTypes[batchUpdateType];
        await exportFunction();
        setIsLoading(false);
    };
    const handleBatchUpdateStatus = (status, successMessage) => {
            if (status === 200) {
                return toast.success(successMessage, toastOptions);
            }

            if (status === 202) {
                return toast.error('Update not successful, please review errors.', toastOptions);
            }

            return toast('Bulk-Import partially successful.\n\nSome lines were successfully updated. Please review errors directly in the document.',
                { icon: '⚠︝' },
                toastOptions);
        };
    return {
        isLoading,
        BatchUpdateExport,
        BatchUpdateImport
    }
};

export default useBulkUpdates;